<template>
  <div class="refund">
    <h3>任务订单结算管理</h3>
    <el-form :inline="true" ref="filter" class="demo-form-inline" size="mini">
      <el-form-item label="结算单号">
        <el-input
          v-model="filter.taskOrderSettlementId"
          placeholder="结算单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="甲方ID">
        <el-input v-model="filter.partyA" placeholder="甲方ID"></el-input>
      </el-form-item>
      <el-form-item label="乙方ID">
        <el-input v-model="filter.partyB" placeholder="乙方ID"></el-input>
      </el-form-item>
      <el-form-item label="乙方昵称">
        <el-input v-model="filter.nickNameB" placeholder="乙方昵称"></el-input>
      </el-form-item>
      <el-form-item label="子订单编号">
        <el-input
          v-model="filter.taskOrderId"
          placeholder="子订单编号"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="报价单号">
        <el-input
          v-model="filter.quotationId"
          placeholder="报价单号"
        ></el-input>
      </el-form-item> -->

      <el-form-item label="结算时间">
        <el-date-picker
          v-model="filter.startSettlementTimeStr"
          type="datetime"
          placeholder="开始时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker
          v-model="filter.endSettlementTimeStr"
          type="datetime"
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结算单状态">
        <el-select v-model="filter.status">
          <el-option
            v-for="(val, key) in settlementStatus"
            :key="key"
            :label="val"
            :value="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="filter.startCreateTimeStr"
          type="datetime"
          placeholder="开始时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker
          v-model="filter.endCreateTimeStr"
          type="datetime"
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fetch(1)" size="mini">查询</el-button>
        <el-button
          class="left-btn"
          type="primary"
          @click="resetQuery()"
          size="mini"
          >重置</el-button
        >
        <!-- <el-button
            style="margin-left: 10px"
            type="primary"
            :disabled="loading_disabled"
            size="mini"
            @click="exportExcel()"
            >导出</el-button
          > -->
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini">
      <el-table-column
        prop="taskOrderSettlementId"
        label="结算单号"
        width="200px"
      ></el-table-column>
      <el-table-column
        width="200px"
        prop="taskOrderId"
        label="子订单编号"
      ></el-table-column>

      <el-table-column
        width="240px"
        prop="title"
        label="任务名称"
      ></el-table-column>
      <el-table-column
        prop="nickNameA"
        label="甲方名称"
        width="200px"
      ></el-table-column>
      <el-table-column
        prop="nickNameB"
        label="乙方名称"
        width="200px"
      ></el-table-column>
      <el-table-column prop="amount" label="结算总额"></el-table-column>

      <el-table-column prop="amountReceive" label="实付金额"></el-table-column>
      <el-table-column prop="amountReceive" label="打款金额"></el-table-column>
      <el-table-column prop="status" label="结算单状态">
        <template slot-scope="scope">{{
          scope.row.status == 0 ? "待结算" : "已结算"
        }}</template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="160px"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="结算时间"
        width="160px"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 1"
            type="text"
            @click="getToken(scope.row)"
            >查看结算详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div style="float: right">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="20"
        @current-change="(i) => (pageNum = i)"
        :page-count="pageNum"
        :total="total"
        ref="pagination"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from "../api";
import map from "../../datamap";
const { settlement, order, taskOrderSettlement } = api;

import moment from "moment";

export default {
  name: "taskFinal",
  data() {
    return {
      map,
      loading: true,
      loading_disabled: false,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      limit: 20,
      filter: {
        limit: 20,
        pageNum: 1,
        nickNameB: "",
        status: "",
        contractId: "",
        quotationId: "",
        taskOrderSettlementId: "",
        startSettlementTimeStr: "",
        endSettlementTimeStr: "",
        partyA: "",
        partyB: "",
        startCreateTimeStr: "",
        endCreateTimeStr: "",
        taskOrderId: "",
      },
      settlementStatus: {
        0: "待结算",
        1: "已结算",
      },
    };
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  created() {},
  methods: {
    async fetch(num) {
      this.loading = true;
      if (num == 1) this.pageNum = 1;
      let {
        nickNameB,
        status,
        contractId,
        quotationId,
        taskOrderId,

        taskOrderSettlementId,
        startSettlementTimeStr,
        endSettlementTimeStr,
        partyA,
        partyB,
        startCreateTimeStr,
        endCreateTimeStr,
      } = this.filter;

      let obj = {
        pageNum: this.pageNum,
        limit: this.limit,
        nickNameB,
        status,
        contractId,
        quotationId,
        taskOrderId,
        taskOrderSettlementId,
        startSettlementTimeStr,
        endSettlementTimeStr,
        partyA,
        partyB,
        startCreateTimeStr,
        endCreateTimeStr,
      };
      // const obj = this.filter;
      let res = await taskOrderSettlement.list(obj);
      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },

    resetQuery() {
      this.filter = {};
      this.pageNum = 1;
      this.fetch();
    },
    getToken(row) {
      // let obj = {
      //   userId: row.partyB,
      // };
      // let {
      //   data: { code, data },
      // } = await order.token(obj);
      // if (code == 200) {
      let url = `${this.frontUrl}/taskHostingPage/billDetail?taskOrderId=${row.taskOrderId}`;
      window.open(url, "_blank");
      // }
    },

    async exportExcel() {
      this.loading = true;
      let obj = this.filter;
      let resp = await settlement.export(obj);
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      link.download = decodeURIComponent("任务结算管理明细列表.xlsx");
      link.href = objectUrl;
      link.click();
      this.loading = false;
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style scoped>
.left-btn {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/taskManage/taskFinal.vue